import { Box, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import GetSiteRec from '../../components/api/GetSiteRec';
import { useNavigate, useParams } from 'react-router-dom';
import { useSite } from '../../components/siteselector/SiteContext';
import { useDate } from '../../components/datepicker/DateContext';
import DatePicker from '../../components/datepicker/DatePicker';
import { tokens } from '../../theme';
import { ResponsiveBullet } from "@nivo/bullet";
import mockData from '../../mockdata/bulletData.json'

const MaintenanceScene = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { siteId } = useParams()
    const [siteName, setSiteName] = useState("");
    const [, setSiteRec] = useState({});
    const navigate = useNavigate();
    const { selectedSite } = useSite();
    const { selectedDate } = useDate();

    useEffect(() => {
        if (siteId !== "undefined") {
          GetSiteRec(siteId).then((response) => {
            const responseVal = response.data["rows"][0]
            setSiteRec(responseVal)
            setSiteName(responseVal["id"]["dis"])
          })
        }
        //scroll after navigating
        document.getElementById('content').scrollTo(0, 0)
    }, [navigate, siteId, siteName, selectedSite, selectedDate]);

    return (
        <Box m="18px" maxWidth="100%">
            {/* TOP ROW - BUTTONS*/}
            <Box display="grid" sx={{ p: "0 0 20px 0" }} >
                <DatePicker />
            </Box>
            <Box display="flex" justifyContent="center" alignItems="center" height="75vh" backgroundColor={colors.primary[400]}>
                <ResponsiveBullet
                    data={mockData}
                    margin={{ top: 50, right: 90, bottom: 50, left: 90 }}
                    spacing={46}
                    titleAlign="start"
                    titleOffsetX={-70}
                    measureSize={0.2}
                    markerColors="seq:blue_green"
                />
            </Box>        
        </Box>
    );
};

export default MaintenanceScene;
